







































































































































import { Component, Vue, Prop, Watch } from "vue-property-decorator";
import { getImgUrl } from "../../utils/dummy";
import SwitchLang from "../SwitchLanguageButton.vue";
import VideoForm from "./VideoForm.vue";
import Modal from "./Modal.vue";
import TextForm from "./TextForm.vue";
import ImageForm from "./ImageForm.vue";
import ExamForm from "./ExamForm.vue";
import RichTextEditor from "./RichTextEditor.vue";
import {
  ADMIN_LESSONS_ENDPOINT,
  COURSES_ENDPOINT,
  ADMIN_COURSES_ENDPOINT,
  LESSONS_ENDPOINT,
  ADMIN_EXAMS_ENDPOINT,
} from "../../store/endpoints";
import axios from "axios";
import { generateAuthHeader } from "../../utils/auth";
import { Getter, Mutation, Action } from "vuex-class";
import { ACCESS_TOKEN, SITE_LANG } from "../../store/getters.names";
import { SET_SITE_LANG } from "../../store/mutations.names";
import { noNullOrInvalid } from "../../utils/common";
import { DELETE_LESSON_CONTENT } from "../../store/actions.names";
import { namespaced, NS_ADMIN } from "../../store/namespace";

const OPTION_DEFAULT = {
  option: { text: "", text_en: "", text_bn: "" },
  correct: false,
};

const CONTENT_BLOCK_DEFAULTS = {
  textItem: {
    text: "",
    text_en: "",
    text_bn: "",
    content_type: "text",
  },
  videoItem: {
    caption: "",
    caption_en: "",
    caption_bn: "",
    link: "",
    file: [],
    transcript: "",
    transcript_en: "",
    transcript_bn: "",
    content_type: "video",
  },
  examItem: {
    name: "",
    name_en: "",
    name_bn: "",
    weight: 0,
    visible_question_count: 1,
    pass_percentage: 40,
    questions: [
      {
        options: [
          JSON.parse(JSON.stringify(OPTION_DEFAULT)),
          JSON.parse(JSON.stringify(OPTION_DEFAULT)),
          JSON.parse(JSON.stringify(OPTION_DEFAULT)),
        ],
        text: "",
        text_en: "",
        text_bn: "",
        hint: "",
        hint_en: "",
        hint_bn: "",
        image: null,
        type: "radio",
        max_show: 3,
      },
    ],
    content_type: "exam",
  },
};

const CONTENTS_TYPE_DEFAULTS = {
  lesson: {
    name: "",
    name_en: "",
    name_bn: "",
    objectives: "",
    objectives_en: "",
    objectives_bn: "",
  },
  exam: JSON.parse(JSON.stringify(CONTENT_BLOCK_DEFAULTS["examItem"])),
};

@Component({
  name: "modalContentBox",
  components: {
    SwitchLang,
    Modal,
    RichTextEditor,
    videoItem: VideoForm,
    textItem: TextForm,
    imgItem: ImageForm,
    examItem: ExamForm,
  },
})
export default class ModalContentBox extends Vue {
  @Getter(ACCESS_TOKEN) accessToken: string;
  @Action(namespaced(NS_ADMIN, DELETE_LESSON_CONTENT))
  deleteLessonContent: any;
  @Prop() readonly show: any;
  @Prop() editData: any | null;
  showModal: boolean = false;
  @Prop() course: string;

  translations = {
    lesson_title: {
      en: "Lesson Title",
      bn: "লেসনের নাম",
    },
    lesson_objectives: {
      en: "Lesson's Objectives",
      bn: "লেসনের উদ্দেশ্য",
    },
  };

  getImgUrl = getImgUrl;
  tabItems: any = {
    videoItem: {
      title: "Video",
      topTabIcon: "img/form-icon/video-icon.svg",
      sideTabIcon: "dummy/img/side-video-icon.svg",
    },
    textItem: {
      title: "Text",
      topTabIcon: "img/form-icon/text-icon.svg",
      sideTabIcon: "dummy/img/edit-icon-pencil.svg",
    },
    // imgItem: {
    //   title: "Image",
    //   topTabIcon: "img/form-icon/img-icon.svg",
    //   sideTabIcon: "dummy/img/img-upload-icon.svg"
    // },
    examItem: {
      title: "Exam",
      topTabIcon: "img/form-icon/exam-icon.svg",
      sideTabIcon: "dummy/img/side-exam-icon.svg",
    },
  };
  contentType: string | null = null;
  step: number = 1;
  lang: string = "bn";
  parentForm: any = {};
  contents: any[] = [];
  validatedMainContent: any = false;
  validatedContents: any = false;
  errors: string[] = [];
  contentErrors: string[] = [];
  // @Watch("contents")
  // handleContentsChange(val, oldVal) {
  //
  // }
  marked_to_delete: Array<number> = [];

  deleteMarkedToDelete() {
    const promises = this.marked_to_delete.map(async (val) => {
      return new Promise((resolve) => {
        this.deleteLessonContent({
          lesson: this.parentForm.id,
          content: val,
        }).then((resp) => {
          resolve("ok");
        });
      });
    });
    return promises;
  }

  removeLessonContent(idx) {
    const content = this.contents[idx];

    if (content.id) {
      this.marked_to_delete.push(content.id);
    }
    this.contents.splice(idx, 1);
  }

  @Watch("editData", { deep: true, immediate: true })
  handleEditDataChange() {
    if (this.editData) {
      this.contentType = this.editData.content_type;
      this.step = 2;
      this.parentForm = JSON.parse(
        JSON.stringify(this.editData.content_object)
      );
      if (this.editData.content_type === "lesson") {
        axios
          .get(
            `${ADMIN_LESSONS_ENDPOINT}${this.editData.content_object.id}`,
            generateAuthHeader(this.accessToken)
          )
          .then(({ data }) => {
            // console.log(data);
            this.contents = data.contents.map((val: any) => {
              val.content_object.content_type = val.content_type;
              return val.content_object;
            });
          });
      }
    }
  }

  resetForms() {
    this.contents = [];
    this.errors = [];
    this.contentErrors = [];
    this.validatedMainContent = false;
    this.validatedContents = false;
    this.editData = null;
  }

  get authHeader(): any {
    return generateAuthHeader(this.accessToken);
  }

  addContent(key) {
    const content = JSON.parse(JSON.stringify(CONTENT_BLOCK_DEFAULTS[key]));
    this.contents = [...this.contents, content];
  }

  langChangeHandler(e) {
    this.lang = e;
  }
  chooseItem(event: any) {
    var currentItem = this.contents.push(
      this.tabItems[event.target.dataset.index]
    );
  }

  videoValidate(data, idx) {
    for (const key in data) {
      if (data.hasOwnProperty(key)) {
        const element = data[key];
        if (key === "id") {
          if (typeof element !== "number") {
            return false;
          }
        } else if (
          ["transcript_en", "caption_en"].indexOf(key) == -1 &&
          element.length === 0
        ) {
          this.errors.push(`Invalid value in ${key}`);
          return false;
        }
      }
    }
    data.file = this.contents[idx].file;
    return data;
  }

  textValidate(data) {
    console.log("FROM TEXT VALIDATE");
    for (const key in data) {
      if (data.hasOwnProperty(key)) {
        const element = data[key];
        if (key === "id") {
          if (typeof element !== "number") {
            return false;
          }
        } else if (element.length === 0) {
          this.errors.push(`Invalid value in ${key}`);
          return false;
        }
      }
    }
    return data;
  }

  optionValidate(data) {
    data.option.text = data.option.text_bn;
    data = noNullOrInvalid(data, ["text_bn"]);
    return data;
  }

  questionValidate(data, idnx, idx: null | number = null) {
    data.text = data.text_bn;
    data.hint = data.hint_bn;
    const img = data.image;
    delete data.image;

    data = noNullOrInvalid(data, [
      "text_en",
      "hint",
      "hint_en",
      "hint_bn",
      "options",
    ]);
    if (data === false) return data;
    if (data.options.length < data.max_show) return false;

    const options = [];
    for (const option of data.options) {
      const v = this.optionValidate(JSON.parse(JSON.stringify(option)));
      if (v === false) {
        return false;
      } else {
        options.push(v);
      }
    }

    data.options = options;
    if (img !== null) {
      data.image =
        idx !== null
          ? this.contents[idx].questions[idnx].image
          : this.parentForm.questions[idnx].image;
    }

    return data;
  }
  examValidate(data: any, idx: number | null = null): any {
    data.name = data.name_bn;
    // console.log(data);
    data = noNullOrInvalid(data, ["name", "name_en", "name_bn", "questions"]);
    // console.log(data);
    if (data === false) return data;
    const questions = [];
    for (const [idnx, question] of data.questions.entries()) {
      const qd = JSON.parse(JSON.stringify(question));
      const v = this.questionValidate(qd, idnx, idx);
      if (v === false) {
        return false;
      } else {
        questions.push(v);
      }
    }
    // console.log("v", data);
    data.questions = questions;
    // console.log(data);
    return data;
  }

  async questionPost(url, data) {
    // console.log(data);
    let qresp;
    let postData;
    let method = "post";
    if (data.id) {
      url = `${url}${data.id}/`;
      method = "patch";
      delete data.id;
    }

    data["options_payload"] = data["options"];
    delete data["options"];

    if (
      data.image === undefined ||
      data.image == null ||
      typeof data.image == "string"
    ) {
      delete data.image;
      postData = data;
    } else {
      let formData = new FormData();
      for (const key in data) {
        if (data.hasOwnProperty(key)) {
          const element = data[key];
          switch (key) {
            case "options_payload":
              formData.append(key, JSON.stringify(element));
              break;
            default:
              formData.append(key, element);
              break;
          }
        }
      }
      postData = formData;
    }
    return await axios({
      method,
      url,
      data: postData,
      ...this.authHeader,
    });
  }

  async examPost(url, data) {
    const questions = data.questions;
    delete data.questions;
    let method = "post";
    url = ADMIN_EXAMS_ENDPOINT;
    if (data.id) {
      method = "patch";
      url = `${url}${data.id}/`;
      delete data.id;
    }

    const examObj = await axios({ method, url, data, ...this.authHeader });
    const qurl = `${ADMIN_EXAMS_ENDPOINT}${examObj.data.id}/questions/`;
    await Promise.all(
      questions.map((item, idx) => {
        this.questionPost(qurl, item);
      })
    );
    return examObj;
  }

  async textPost(url, data) {
    return await axios.post(url, data, this.authHeader);
  }
  async videoPost(url, data) {
    let method = "post";
    const form = new FormData();
    for (const key in data) {
      if (data.hasOwnProperty(key)) {
        const element = data[key];
        switch (key) {
          case "file":
            if (typeof element == "object") {
              form.append(key, element[0]);
            }
            break;
          // case "id":
          //   method = "patch";
          //   url = `${url}${data["id"]}/`;
          //   delete data.id;
          //   break;
          default:
            form.append(key, element);
        }
      }
    }
    return await axios({
      method,
      url,
      data: form,
      ...this.authHeader,
    });
  }

  validatedLessonData(): any {
    let result: any;
    if (this.contentType != "lesson") {
      result = false;
    }
    const data = JSON.parse(JSON.stringify(this.parentForm));

    //console.log(data);
    data.name = data.name_bn;
    data.objectives = data.objectives_bn;

    const invalids = Object.keys(data).find((key: string) => {
      const d = data[key];
      switch (key) {
        case "id":
          return !(typeof d == "number");
        case "name_bn":
        case "objectives_bn":
          return !(d && d != null);
        case "name_en":
        case "objectives_en":
          return false;
        default:
          return !(d && d != null && d.length > 0);
      }
    });
    //console.log(invalids);

    if (invalids == undefined) {
      result = data;
    } else {
      result = false;
    }
    this.validatedMainContent = result;
  }

  validate() {
    const contents = JSON.parse(JSON.stringify(this.contents));
    const validatedData = contents.map((val, idx) => {
      return this[`${val.content_type}Validate`](
        JSON.parse(JSON.stringify(val)),
        idx
      );
    });

    const falsy = validatedData.filter((val) => {
      return val === false;
    });
    if (falsy.length > 0) {
      this.validatedContents = false;
    } else {
      this.validatedContents = validatedData;
    }
  }

  async createExamContent() {
    // console.log(this.parentForm);
    this.validatedMainContent = this.examValidate(
      JSON.parse(JSON.stringify(this.parentForm))
    );
    // console.log(this.validatedMainContent);
    if (this.validatedMainContent) {
      let examData = await this.examPost(
        ADMIN_EXAMS_ENDPOINT,
        this.validatedMainContent
      );

      if (!this.parentForm.id) {
        var lastRequest = await axios.post(
          `${ADMIN_COURSES_ENDPOINT}${this.course}/contents/`,
          { object_id: examData.data.id, content_type: "exam" },
          this.authHeader
        );
      }
      this.close();
    }
  }

  async createLessonContent() {
    this.validatedLessonData();
    this.validate();
    if (this.validatedMainContent && this.validatedContents) {
      let method = "post";
      let url = ADMIN_LESSONS_ENDPOINT;
      let data = JSON.parse(JSON.stringify(this.validatedMainContent));
      if (this.parentForm.id) {
        method = "patch";
        url = `${ADMIN_LESSONS_ENDPOINT}${this.validatedMainContent.id}/`;
        delete data.id;
      }
      const lessonData = await axios({
        method,
        url,
        data,
        ...this.authHeader,
      });

      const content_url = `${ADMIN_LESSONS_ENDPOINT}${lessonData.data.id}/contents/add_content/`;
      for (const content of this.validatedContents as any) {
        let d = await this[`${content.content_type}Post`](content_url, content);
      }
      if (method === "post") {
        var lastRequest = await axios.post(
          `${ADMIN_COURSES_ENDPOINT}${this.course}/contents/`,
          { object_id: lessonData.data.id, content_type: "lesson" },
          this.authHeader
        );
      }
      this.close();
    }
  }

  // Modal Function

  close() {
    this.resetForms();
    this.$emit("close");
  }

  closeModal() {
    this.close();
  }

  prev() {
    this.step--;
  }
  next() {
    switch (this.step) {
      case 2:
        if (this.contentType == "lesson") {
          this.validatedLessonData();
          if (this.validatedMainContent) {
            // console.log("valid");
            this.parentForm = this.validatedMainContent;
            this.step++;
          }
        }
        if (this.contentType == "exam") {
          this.createExamContent();
        }
        break;
      case 3:
        if (this.contentType == "lesson") {
          Promise.all(this.deleteMarkedToDelete()).then((vals) => {
            this.createLessonContent();
          });
        }
        break;
      default:
        this.step++;
        break;
    }
  }

  selectContentType(t: string) {
    this.contentType = t;
    this.parentForm = JSON.parse(JSON.stringify(CONTENTS_TYPE_DEFAULTS[t]));
    this.step = 2;
  }
}
